var cilWifiSignal0 = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M237.778,480h36.444L504,151.842V124.4l-.215-.15a432.019,432.019,0,0,0-495.57,0L8,124.4v27.438ZM256,78.128a397.867,397.867,0,0,1,216.144,63.419L256,450.232,39.856,141.547A397.867,397.867,0,0,1,256,78.128Z' class='ci-primary'/>"];

export { cilWifiSignal0 };

